/* Struxa: catalogue image repair.
 *
 * The vehicle finder and the catalogue draw their card images from the URL
 * held in the Google Sheet, not from Shopify's product media, so the two can
 * drift. Two ways that has bitten us:
 *
 *   1. A file gets deleted or renamed in Shopify Files and the sheet keeps
 *      pointing at the old URL - the card renders a broken image and nobody
 *      notices, because the product page itself is fine.
 *   2. A render is superseded but the sheet still names the old one.
 *
 * This is the safety net for both: a filename map for known-bad renders, and
 * an error handler that swaps anything that fails to load for a plain strut.
 * It reads its URLs off the window so the Liquid layer owns the asset paths.
 *
 * The real fix for any entry below is the sheet. This only stops a stale row
 * from showing a customer a hole.
 */
(function () {
  'use strict';

  var MAP = {};
  // Old render: a moulded collar sat on the shaft behind the socket, which is
  // not what we ship. Superseded by the f6sp tube / metal socket shaft render.
  if (window.SX_IMG_F6SP_METAL) { MAP['f6sp_metal_mixed_final.png'] = window.SX_IMG_F6SP_METAL; }

  var FALLBACK = window.SX_IMG_FALLBACK || '';

  function nameOf(u) {
    if (!u) { return ''; }
    try { return decodeURIComponent(String(u).split('?')[0].split('/').pop()); }
    catch (e) { return String(u).split('?')[0].split('/').pop(); }
  }

  function fix(img) {
    if (!img || img.getAttribute('data-sx-img') === '1') { return; }
    img.setAttribute('data-sx-img', '1');

    var to = MAP[nameOf(img.getAttribute('src'))];
    if (to) { img.src = to; return; }

    if (!FALLBACK) { return; }
    img.addEventListener('error', function () {
      // One swap only - if the fallback itself fails, leave it alone rather
      // than looping.
      if (img.src.indexOf(FALLBACK) === -1) { img.src = FALLBACK; }
    });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) { return; }
    Array.prototype.forEach.call(root.querySelectorAll('img'), fix);
  }

  function boot() {
    scan(document);
    // Cards are rendered after a make is chosen, so a one-off scan is not
    // enough. Only watch on the pages that actually build cards.
    if (!document.querySelector('.sx-vf, .gsc-cfg, .sxp-shell')) { return; }
    if (typeof MutationObserver !== 'function') { return; }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) { continue; }
          if (n.tagName === 'IMG') { fix(n); } else { scan(n); }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
